import React, { Component } from 'react';
import MtSvgLines from 'react-mt-svg-lines';  
import Api from './Api';
import _ from 'lodash';


const { $, NProgress } = window;

export default class Form extends Component {

	constructor(props) {
		super(props);
		
        this.state = {
            errors: {},
            generalError: '',
            success: false,
            shareUrl: ''
        };
        
        this.onSubmit = this.onSubmit.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.isNumber = this.isNumber.bind(this);
        this.onShare = this.onShare.bind(this);
        this.onChangeInput = this.onChangeInput.bind(this);
    }

    onSubmit(event) {
        event.persist();
        event.preventDefault();

      //  const { FB } = window;

        const data = $(event.target).serialize();
        
        this.setState({errors: {}, generalError: null});

        NProgress.start();

        /*let sharePopup = null;
        if (event.target.share.checked) {
            sharePopup = window.open('about:blank', 'fbshare', 'width=600, height=500');
            sharePopup.blur();
            window.focus();
        }*/

        Api.post('ajax-save.php', data).then((res) => {
            NProgress.done();
            
            res = res.data;
            if (res.result === 1) {
                this.setState({success: true});
            
                this.props.onSave(true);
                this.setState({shareUrl: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(res.shareUrl)});

               /* if (sharePopup) {
                    sharePopup.location.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(res.shareUrl);
                    sharePopup.focus();
                }*/

                Api.get('ajax-fb.php?id=' + res.id);
                    
            } else {
                this.setState({
                    generalError: res.msg,
                    errors: res.errors
                });
                /*if (sharePopup) {
                    sharePopup.close();
                }*/
            }
        });

    }

    onChangeInput(event){

        var key = event.target.name;
        
        if (key === 'phone' ){
            if( !(/^\d{9}$/.test(event.target.value)) ) {
              return false;
            }
        }
        delete this.state.errors[key]; 
        var newErrors = this.state.errors;        
        this.setState({errors: newErrors});


    }
    onShare(){
        // let sharePopup;
        // sharePopup = window.open(this.state.shareUrl , 'fbshare', 'width=600, height=500');
       // sharePopup.location.href = this.state.shareUrl ;
        window.open(this.state.shareUrl , 'fbshare', 'width=600, height=500');
    }

    onDownloadClick(event) {
        
        const clone = this.form.cloneNode(true);

        clone.style.display = 'none';
        clone.action = Api.url('download-map.php');
        clone.method = 'post';
        clone.target = '_blank';

        document.body.appendChild(clone)

        clone.submit();

        // El timeout es para que el GTM deje submitear el form
        setTimeout(function() {
            clone.remove();
        }, 1500);

        event.preventDefault();
    }
    isNumber(e){
 
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
             // Allow: Ctrl+A, Command+A, Ctrl+X, Command+X, Ctrl+C, Command+C Ctrl+V, Command+V
            (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) || 
            (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) || 
            (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) || 
            (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) || 
             // Allow: home, end, left, right, down, up
            (e.keyCode >= 35 && e.keyCode <= 40)) {
                 // let it happen, don't do anything
                 return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    }
    
    
    
	render() {
        const hasErrors = _.isEmpty(this.state.errors) !== false;

        let defaultValue = {}
        if (process.env.NODE_ENV === 'development') {
            defaultValue = {
                title: 'Una aventura',
                name: 'El nombre del niño',
                name_user: 'El apellido del niño',
                age: 9,
                phone: 666666666
            }
        }

        const user = JSON.parse(localStorage.loggedUser);

		return (
            <div className="form-container"><div className="display-t"><div className="display-tc">              
                    

                {
                    this.state.success 
                    ?   <div className="form-suscess">
                            <div className="display-t"><div className="display-tc">
                                <MtSvgLines animate={ true } duration={ 500 }>
                                  <svg viewBox="0 0 100 100">
                                      <g fill="none" strokeMiterlimit="1">
                                        <circle fill="#45bf23" cx="50" cy="50" r="45"/>
                                        <path stroke="#FFF" strokeWidth="6" d="M20.8,51c0,0,20.8,18.2,21.5,18.2c0.6,0,33.3-38.5,33.3-38.5"/>
                                      </g>
                                    </svg>
                                </MtSvgLines>
                                <p>Gracias por participar en la <strong>#AventuraIncreíble.</strong></p>
                                <p>Pide el voto a tus contactos y hazla realidad a tamaño real en el Salón del Automóvil de Barcelona.</p>
                                <button type="button" className="btn-facebook hvr-float-shadow" onClick={this.onShare.bind(this)}><i className="fa fa-facebook"></i><span>COMPARTIR EN MI MURO</span></button>
                            </div></div>
                        </div>
                     
                    :   <form className="form" onSubmit={this.onSubmit} ref={(el) => this.form = el}  autoComplete="off">


                            <input type="hidden" name="fb_uid"  defaultValue={user.id} />
                            <input type="hidden" name="fb_name" defaultValue={user.name} />
                            <input type="hidden" name="email"   defaultValue={user.email} />
                            <input type="hidden" name="data"    value={this.props.mapData} />

                            {
                               /* !hasErrors &&

                                    <ul className="text-error ">
                                        {                                            
                                            _.map(this.state.errors, (obj, key) => {
                                                return <li key={key}>{obj}</li>
                                            })
                                        }
                                    </ul>*/
                            }
                           
                            <div className="row">
                                <div className={(!hasErrors && this.state.errors.title  ? "has-error " : "") + ' form-group col-sm-12'}>
                                    <label className="control-label">Pon nombre a tu aventura</label>
                                    <input className="form-control gradientYellow" type="text" name="title" defaultValue={defaultValue.title} onChange={this.onChangeInput} />
                                </div>
                            </div>



                            <div className="row">
                                <div className={(!hasErrors && this.state.errors.name  ? "has-error " : "") + ' form-group col-sm-6'}>
                                    <label className="control-label">Nombre del niño</label>
                                    <input className="form-control gradientGreen" type="text" name="name" defaultValue={defaultValue.name} onChange={this.onChangeInput} />
                                </div>
                                <div className={(!hasErrors && this.state.errors.name_user  ? "has-error " : "") + ' form-group col-sm-6'}>
                                    <label className="control-label">Nombre del usuario</label>
                                    <input className="form-control gradientGreen" type="text" name="name_user" defaultValue={defaultValue.name_user} onChange={this.onChangeInput} />
                                </div>

                              
                            </div>

                            <div className="row">
                                <div className={(!hasErrors && this.state.errors.age  ? "has-error " : "") + ' form-group col-sm-4'}>
                                    <label className="control-label" style={{height: '40px'}}>Edad del niño</label>
                                    <select className="form-control gradientGreen" name="age" defaultValue={defaultValue.age}>
                                        {
                                            _.range(6, 13).map((val, key) => {
                                                return <option key={key} value={val}>{val}</option>
                                            })
                                        }
                                    </select>
                                </div>
                                <div className={(!hasErrors && this.state.errors.phone  ? "has-error " : "") + ' form-group col-sm-8'}>
                                    <label className="control-label">Teléfono del usuario del perfil de Facebook</label>
                                    <input className="form-control gradientGreen" type="text" name="phone" defaultValue={defaultValue.phone}  onKeyDown={this.isNumber} maxLength="9" onChange={this.onChangeInput}/>
                                </div>
                            </div>

                            <div className={(!hasErrors && this.state.errors.accept  ? "has-error " : "") + ' form-group checkbox'}>
                                <input type="checkbox" name="accept" id="accept" onChange={this.onChangeInput}/>                                
                              
                                <label htmlFor="accept"><span className="check"></span> Acepto la <a className="link" href="http://www.landrover.es/privacy-policy.html" target="_blank" style={{textDecoration:'underline'}}>política de privacidad</a> de Land Rover y los <a className="link" href="http://www.landrover.es/vehicles/discovery/bases-aventura-increible.html" target="_blank" style={{textDecoration:'underline'}}>términos y condiciones</a>.</label>

                            </div>

                             <div className={(!hasErrors && this.state.errors.info_comercial  ? "has-error " : "") + ' form-group checkbox'}>
                                <input type="checkbox" name="info_comercial" id="info_comercial" value="1"/>                                
                              
                                <label htmlFor="info_comercial"><span className="check"></span> Acepto que Land Rover me envíe información comercial.</label>

                            </div>



                            <div className="row btn-actions">
                                <div className="col-sm-12">
                                    {this.state.generalError &&
                                        <div className="helper-text error">{this.state.generalError}</div>
                                    }
                                </div>
                                <div className="col-sm-8">
                                    <button type="submit" className="btn-facebook hvr-float-shadow"><i className="fa fa-facebook"></i><span>PARTICIPA<br/>CON TU AVENTURA</span></button>
                                </div>
                                <div className="col-sm-4">
                                    <button className="btn-download hvr-float-shadow" onClick={this.onDownloadClick.bind(this)}>
                                        <i className="icon-download-inv "></i><span>DESCARGA<br/>LA IMAGEN</span>
                                    </button>
                                </div>
                                
                                {
                                /* 
                                <div className="col-sm-12">

                                    <div className="form-group checkbox">
                                        <input type="checkbox" name="share" id="share"/>
                                        <label htmlFor="share"><span className="check"></span> Compartir en mi muro</label>
                                    </div>
                                    <div className="helper-text">
                                        Al hacer clic en PARTICIPA CON TU AVENTURA, el mundo que has creado pasará a formar parte del concurso. Si tu propuesta resulta elegida... ¡se hará realidad!
                                    </div>
                                </div>
                                */
                                }

                            </div>                        

                    </form>
                    
                }
            </div> </div> </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Form.js